export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    if (state.searchText) {
      const searchText = state.searchText.toLowerCase();
      return `nomeLocal like '%${searchText}%' or codigoInterno like '%${searchText}%' or observacoesInternas like '%${searchText}%'`;
    }
    return '';
  },
};
